import { Step, Stepper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomStepper = styled(Stepper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    color: 'red',
    
    '& .MuiStepLabel-iconContainer': {
        "@media (max-width: 600px)": {
            paddingRight: "0"
        }
    } 
}));

export const CustomStep = styled(Step)(({ theme }) => ({
    padding: 0
}));

export const CustomStepIconContainer = styled('div')<{ ownerState: { active?: boolean } }>(
    ({ theme, ownerState }) => ({
        color: theme.colors["neutral.500"],
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        ...(ownerState.active && {
            color: theme.colors['lime.400'],
        })
    }),
);

export const CustomCircleIcon = styled('div')(({ theme }) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    '&.is-completed': {
        color: theme.colors["neutral.50"],
    }
}));

export const CustomLabel = styled('div')(({ theme }) => ({
    '&.is-completed': {
        color: theme.colors["neutral.50"],
    }
}));
